export enum ReceiveBiometricMessages {
  allowBiometric = 'allowBiometric',
  enableBiometric = 'enableBiometric',
  disableBiometric = 'disableBiometric',
  biometricAuthenticate = 'biometricAuthenticate',
}

export enum SendBiometricMessages {
  ready = 'ready',
  enableBiometric = 'enableBiometric',
  disableBiometric = 'disableBiometric',
  biometricAuthenticate = 'biometricAuthenticate',
}

export interface IBiometricInfo {
  success: boolean;
  error: string;
  enabled: boolean;
}

export interface IBiometric {
  authenticate: () => void;
  biometricInfo: IBiometricInfo;
  enableBiometric: (payload: Record<string, string>) => void;
}
